import { Link } from "react-router-dom";
import { useGetAssignmentsQuery } from "../../../features/Assignments/assignmentsApi";
import AssignmentItem from "./AssignmentItem";
import routes from "../../../config/routeConfig";

export default function Assignments() {
  const { data: assignments, isError, isLoading } = useGetAssignmentsQuery();

  return (
    <div className="px-3 py-20 bg-opacity-10">
      <div className="w-full flex">
        <Link to={routes.admin.addAssignment} className="ml-auto">
          <button className="btn">Add Assignment</button>
        </Link>
      </div>
      <div className="overflow-x-auto mt-4">
        <table className="divide-y-1 text-base divide-gray-600 w-full">
          <thead>
            <tr>
              <th className="table-th">Title</th>
              <th className="table-th">Video Title</th>
              <th className="table-th">Mark</th>
              <th className="table-th">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-600/50">
            {isLoading && (
              <tr>
                <td className="text-center" colSpan="100%">
                  Loading assignments...
                </td>
              </tr>
            )}
            {isError && (
              <tr>
                <td className="text-center" colSpan="100%">
                  Failed to fetch assignments!
                </td>
              </tr>
            )}
            {!isLoading && assignments.length === 0 && (
              <tr>
                <td className="text-center" colSpan="100%">
                  No assignments found!
                </td>
              </tr>
            )}

            {assignments?.map((assignment) => (
              <AssignmentItem assignment={assignment} key={assignment.id} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
